import { Control, UseFormSetValue } from "react-hook-form";
import { usePricingConfigurator } from "../../hooks/use-pricing-configurator";
import { ParkingRateFormValues } from "../../parking-payment.const";
import { RateTypeEnum } from "../../pricing-configurator.types";
import { AnchorInputSection } from "./anchor-input-section";
import { PricingGenerationMode } from "./pricing-generation-mode";
import { CompiledPricingPointsPreview } from "./compiled-pricing-points-preview";
import { PricingRoundingRules } from "./pricing-rounding-rules";

type ShortDurationConfiguratorProps = {
  control: Control<ParkingRateFormValues>;
  setValue: UseFormSetValue<ParkingRateFormValues>;
};

export const ShortDurationConfigurator = ({ control, setValue }: ShortDurationConfiguratorProps) => {
  const {
    anchors,
    timeStep,
    priceStep,
    generationMode,
    generatedPricing,
    roundTo,
    roundMode,
    keepAnchorsExact,
    insertAnchorAfter,
    reorderAnchors,
    removeAnchor,
    updateAnchor,
    toggleShortcut,
    setAnchors,
    setGenerationMode,
    setTimeStep,
    setPriceStep,
    setRoundTo,
    setRoundMode,
    setKeepAnchorsExact,
    resetToDefault,
  } = usePricingConfigurator({ control, setValue, rateType: RateTypeEnum.SHORT });

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:items-stretch">
      <div className="space-y-6">
        <div className="space-y-3">
          <AnchorInputSection
            anchors={anchors}
            onRemoveAnchor={removeAnchor}
            onUpdateAnchor={updateAnchor}
            onInsertAnchorAfter={insertAnchorAfter}
            onReorderAnchors={reorderAnchors}
            onToggleShortcut={toggleShortcut}
            onApplyAsAnchors={setAnchors}
          />
        </div>
        <div className="space-y-3">
          <div>
            <h3 className="text-sm font-medium">Mode de génération</h3>
            <p className="text-xs text-muted-foreground">Comment remplir les intervalles entre les points d'ancrage</p>
          </div>
          <PricingGenerationMode
            generationMode={generationMode}
            onGenerationModeChange={setGenerationMode}
            timeStep={timeStep}
            onTimeStepChange={setTimeStep}
            priceStep={priceStep}
            onPriceStepChange={setPriceStep}
          />
        </div>
        <PricingRoundingRules
          roundTo={roundTo}
          onRoundToChange={setRoundTo}
          roundMode={roundMode}
          onRoundModeChange={setRoundMode}
          keepAnchorsExact={keepAnchorsExact}
          onKeepAnchorsExactChange={setKeepAnchorsExact}
        />
      </div>
      <div className="flex flex-col h-full">
        <CompiledPricingPointsPreview
          generatedPricing={generatedPricing}
          anchorsCount={anchors.length}
          onReset={resetToDefault}
        />
      </div>
    </div>
  );
};
